import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1zm9 -1v18","key":"svg-0"}]]

const IconColumns2 = createReactComponent('outline', 'columns-2', 'Columns2', __iconNode);

export default IconColumns2;